import { useAppDispatch } from "../../../store/hooks/StoreHooks"
import { gasCalculationStart, setBasicGasCalculation, setGasCalculationComplete, setGasIntakeData } from "../../../store/jetlift/jetlift-output/GasCalculationSlice";

const useJetliftGasCalculationFacade = () => {
    const dispatch = useAppDispatch();

    const GasCalculationStart = () => {
        dispatch(setGasCalculationComplete(false));
        dispatch(gasCalculationStart());
    };

    const getBasicGasCalculation = (payload: any) => {
        return dispatch(setBasicGasCalculation(payload));
    };

    const getGasIntakeData = (payload: any) => {
        return dispatch(setGasIntakeData(payload));
    };

    return {
        GasCalculationStart,
        getBasicGasCalculation,
        getGasIntakeData,
    }
};

export default useJetliftGasCalculationFacade;